module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-social-media-templates-instagram-sieron-Kinesitherapie-brakel-3.761db2ca.jpg";